import { Images } from 'assets/images';
import {
  ModalContent,
  ModalWrapper,
  CloseModalIcon,
  ConfirmPasswordText,
  ForYourSecurityText,
  PasswordInput,
  PasswordAndLogOutButtons,
  CancelButton,
  LogOutBrowserSessionButtons,
  LogOutButton,
} from 'admin/components/ProfileModals/styled';

export const ProfileLogOutModal = ({ handleConfirmModal }) => (
  <ModalWrapper>
    <CloseModalIcon src={Images.closeBlueIcon} onClick={handleConfirmModal} />
    <ModalContent isLogOut>
      <ConfirmPasswordText>Log Out Other Browser Sessions</ConfirmPasswordText>
      <ForYourSecurityText>
        Please enter your password to confirm you would like to log out of your other
        browser sessions across all of your devices.
      </ForYourSecurityText>

      <PasswordAndLogOutButtons>
        <PasswordInput placeholder="Password" isLogOut />
        <LogOutBrowserSessionButtons>
          <CancelButton onClick={handleConfirmModal}>Cancel</CancelButton>
          <LogOutButton onClick={handleConfirmModal}>
            Log Out Other Browser Session
          </LogOutButton>
        </LogOutBrowserSessionButtons>
      </PasswordAndLogOutButtons>
    </ModalContent>
  </ModalWrapper>
);
